import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  const loading: Ref<boolean> = ref(false)

  function start() {
    loading.value = true
  }
  function stop() {
    loading.value = false
  }

  return {
    loading,
    start,
    stop,
  }
})
